
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      // image animation
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs['platform-container'],
          start: 'top center',
          // markers: true,
        },
      })

      tl.from('#platform-img', {
        alpha: 0,
        xPercent: 20,
      })

      tl.from(this.$refs['list-container'], {
        alpha: 0,
        y: -10,
        stagger: 0.2,
      })
    },
  },
}
